import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Connect from "./components/Connect";
import Client from "./components/Client";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/connect" replace />} />
          <Route path="/connect" element={<Connect />} />
          <Route path="/client" element={<Client />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;